import styled from 'styled-components';
import SidebarNavDesktop from './SidebarNavDesktop';
import SidebarNavMobile from './SidebarNavMobile';

const NavContainer = styled.nav`
  -webkit-box-flex: 0;
  -ms-flex: 0 0 200px;
  flex: 0 0 200px;
  margin-right: 60px;
  @media screen and (max-width: 1000px) {
    flex-basis: auto;
    margin-right: 0;
    margin-bottom: 22px;
  }
`;

function AnalyticsSidebar() {
  return (
    <NavContainer role="navigation">
      <SidebarNavDesktop />
      <SidebarNavMobile />
    </NavContainer>
  );
}

export default AnalyticsSidebar;
